import { render } from "./PhotoBlock.vue?vue&type=template&id=2729593c"
import script from "./PhotoBlock.vue?vue&type=script&lang=js"
export * from "./PhotoBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/PhotoBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2729593c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2729593c', __exports__)) {
    api.reload('2729593c', __exports__)
  }
  
  module.hot.accept("./PhotoBlock.vue?vue&type=template&id=2729593c", () => {
    api.rerender('2729593c', render)
  })

}


export default __exports__